import {helpSvg as Icon__small__helpSvg} from '../Icon__small/Icon__small--help.js'

export var help = {
  name: 'help',
  category: 'icon',
  colorable: true,
  svg: Icon__small__helpSvg,
};
